import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { enableMapSet } from 'immer';
import * as Sentry from "@sentry/react";
import './index.css';
import { Amplify } from 'aws-amplify';
import config from './config';
import crossworthyRouter from './CrossworthyRouter';
import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

enableMapSet();

/* Set the DEV or PROD stage in the following line. */
const STAGE = "PROD";    // "DEV" or "PROD"

export const stageConfig = STAGE === "PROD" ? config.PROD : config.DEV;
// Warn user if in DEV stage
if (STAGE !== "PROD") {
  alert("Warning! You're using the DEV stage. Switch to PROD in index.js before shipping. Remember to check config.js to ensure all PROD endpoints are properly configured.");
}


Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
});



/* Configure API routes based on stage */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: stageConfig.cognito.APP_CLIENT_ID,
      userPoolId: stageConfig.cognito.USER_POOL_ID,
      identityPoolId: stageConfig.cognito.IDENTITY_POOL_ID,
      allowGuestAccess: true,
    },
  },
  API: {
    REST: Object.fromEntries(
      Object.entries(stageConfig.apiGateway.URLs).map(([name, endpoint]) => [name, { endpoint, region: stageConfig.apiGateway.REGION }])
    ),
  },
});




async function setSentryUserFromAmplify() {
  try {
    const session = await fetchAuthSession();

    if (!session?.tokens) {
      Sentry.setUser(null);
      return;
    }

    const id = session.tokens.idToken?.payload?.sub;
    const email = session.tokens.idToken?.payload?.email;

    Sentry.setUser({
      id,
      email,
    });
  } catch (error) {
    Sentry.setUser(null);
  }
}

// Initial load
setSentryUserFromAmplify();

// Listen for auth state changes
Hub.listen("auth", ({ payload }) => {
  switch (payload.event) {
    case "signedIn":
    case "tokenRefresh":
      setSentryUserFromAmplify();
      break;
    case "signedOut":
      Sentry.setUser(null);
      break;
    default:
      break;
  }
});




const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RouterProvider router={crossworthyRouter} />
  </React.StrictMode>
);
